import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let DateselectComp;

class Dateselect extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: DateselectComp};
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/dateselect-comp" */
            "../../../components/javascript/zcat-components/dateselect-comp"
        ).then(function(res) {
            DateselectComp = res.DateselectComp;
        }));

        
;
    }
}

export {Dateselect};

